import { useEffect, useState } from "react";
import { url } from "../utils/config";
import axios from "axios";
import Select from "../reusable_components/Select";
import Input from "../reusable_components/Input";
import postData from "../custom_functions/postData";
import { toast } from "react-toastify";
import Button from "../reusable_components/Button";
import { btnCancel, btnOne, inputStyle, label, modalContainer, modalTitle } from "../utils/style";


function AddMobileVan(props) {
    const [formData, setFormData] = useState({});
    const [carInfo, setCarInfo] = useState({});
    const [cars, setCars] = useState([]);
    const [missingFields, setMissingFields] = useState([]);
    const [inputErrors, setInputErrors] = useState([]);
    const [showInputError, setShowInputError] = useState(false);

    const requiredFields = ['make', 'model', 'year', 'registrationDate', 'insuranceValidity'];

    useEffect(() => { fetchCars() }, [])

    async function addMobileVan() {
        if (
            carInfo.make && getMakeList().includes(carInfo.make) &&
            carInfo.model &&
            carInfo.year &&
            formData.registrationDate && new Date(formData.registrationDate).getTime() <= new Date(new Date(Date.now()).toLocaleDateString()).getTime() &&
            formData.insuranceValidity && new Date(formData.insuranceValidity).getTime() >= new Date(new Date(Date.now()).toLocaleDateString()).getTime() &&
            !inputErrors.includes('error')
        ) {
            console.log('Validated')
            const car_id = cars.filter(car => car.make === carInfo.make && car.model === carInfo.model && car.year === carInfo.year)[0]['id'];
            postData(`${url}/mobile_van`, { ...formData, car_id }, (error) => {
                toast.error(error.response.data.message, { autoClose: 3000 })
            }, (data) => {
                toast.success('Van Addedd Successfully!', { autoClose: 3000 });
                props.setShowModal(false);
                props.reload(1 + Math.random())
            })
        } else {
            let fields = Object.keys(formData);
            let miss = [];
            if (fields.length !== requiredFields.length) {
                requiredFields.forEach(field => {
                    if (!fields.includes(field)) {
                        miss.push(field)
                    }
                })
            };
            setMissingFields(miss);
            setShowInputError(true)
        }
    }

    async function fetchCars() {
        try {
            const reqUrl = url + '/cars';
            const token = window.localStorage.getItem('token');
            const headers = { authorization: `bearer ${token}` };
            const { data } = await axios.get(reqUrl, { headers });
            console.log(data);
            setCars(data.data)
        } catch (error) {
            console.log(error)
        }
    }

    function getMakeList() {
        const make = [];
        cars.forEach(car => {
            if (!make.includes(car.make)) {
                make.push(car.make)
            }
        })
        return make;
    }

    function updateFormData(e) {
        const { name, value } = e.target;
        if (name === 'insuranceValidity' && value.length > 10) return
        var data = { ...formData };
        data[name] = value;
        setFormData(data);
    }

    function updateCarInfo(e) {
        const { name, value } = e.target;
        if (value !== 1) {
            var data = { ...carInfo };
            data[name] = value;
            setCarInfo(data);
            console.log(data)
        }
    }

    return (
        <div className={modalContainer}>
            <div className="bg-white rounded-md p-6 w-2/3">
                <div>
                    <div className={modalTitle}>Add Mobile Van</div>
                    <div className="">
                        <div className="grid grid-cols-6 gap-4 py-1 px-2">
                            <div className={label}>Make</div>
                            <div className="col-span-2">
                                <Select
                                    index={0}
                                    inputErrors={inputErrors}
                                    setInputErrors={setInputErrors}
                                    missingFields={missingFields}
                                    required={true}
                                    className={inputStyle}
                                    name='make'
                                    placeHolder='Make'
                                    value={carInfo.make}
                                    options={getMakeList()}
                                    onChange={e => updateCarInfo(e)}
                                />
                            </div>
                            <div className={label}>Model</div>
                            <div className="col-span-2">
                                <Select
                                    index={1}
                                    inputErrors={inputErrors}
                                    setInputErrors={setInputErrors}
                                    missingFields={missingFields}
                                    required={true}
                                    className={inputStyle}
                                    name='model'
                                    placeHolder='Model'
                                    value={carInfo.model}
                                    valueKey={'model'}
                                    nameKey={'model'}
                                    options={cars.filter(car => car.make === carInfo.make)}
                                    onChange={e => updateCarInfo(e)}
                                />
                            </div>
                        </div>

                        <div className="grid grid-cols-6 gap-4 py-1 px-2">
                            <div className={label}>Year</div>
                            <div className="col-span-2">
                                <Select
                                    index={2}
                                    inputErrors={inputErrors}
                                    setInputErrors={setInputErrors}
                                    missingFields={missingFields}
                                    required={true}
                                    className={inputStyle}
                                    name='year'
                                    placeHolder='Year'
                                    value={carInfo.year}
                                    valueKey={'year'}
                                    nameKey={'year'}
                                    options={cars.filter(car => car.make === carInfo.make && car.model === carInfo.model)}
                                    onChange={e => updateCarInfo(e)}
                                />
                            </div>

                            <div className={label}>Registration Date</div>
                            <div className="col-span-2">
                                <Input
                                    index={3}
                                    inputErrors={inputErrors}
                                    setInputErrors={setInputErrors}
                                    missingFields={missingFields}
                                    required={true}
                                    max={new Date(Date.now()).toLocaleDateString()}
                                    className={inputStyle}
                                    name='registrationDate'
                                    type="date"
                                    value={formData.registrationDate}
                                    onChange={e => updateFormData(e)}
                                />
                            </div>
                            <div className={label}>Insurance</div>
                            <div className="col-span-2">
                                <Input
                                    index={4}
                                    inputErrors={inputErrors}
                                    setInputErrors={setInputErrors}
                                    missingFields={missingFields}
                                    required={true}
                                    min={new Date(Date.now()).toLocaleDateString()}
                                    className={inputStyle}
                                    name='insuranceValidity'
                                    type="date"
                                    value={formData.insuranceValidity}
                                    onChange={e => updateFormData(e)}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="flex justify-between py-3 px-16 gap-8">
                        <button onClick={e => props.setShowModal(false)} className={btnCancel}>Cancel</button>
                        <Button clickHandler={e => addMobileVan()} className={btnOne} name={'Submit'} />
                    </div>
                    <div className="text-red-500 font-semibold text-center">
                        {
                            showInputError && 'Please fill all the fields as directed!'
                        }
                    </div>
                </div>
            </div>
        </div>
    )

}

export default AddMobileVan;